import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import {
  Container,
  Typography,
  TextField,
  Button,
  Snackbar,
  Alert,
  CircularProgress,
  Slide,
  Paper,
  MenuItem,
  Box,
} from "@mui/material";
import { Autocomplete } from "@mui/material";
import { OrderContext } from "../contexts/OrderContext";
import "../assets/styles/ordercreation.css";
import { useDropzone } from "react-dropzone";
import { useNavigate } from "react-router-dom";
import {
  AllInbox,
  LibraryAddOutlined,
  StorefrontOutlined,
} from "@mui/icons-material";

// Secondary actions in the page header (Bulk / Exhibition orders)
const headerActionSx = {
  height: 40,
  px: 2,
  flex: { xs: 1, md: "0 0 auto" },
  whiteSpace: "nowrap",
  borderRadius: "8px",
  borderColor: "#D0D5DD",
  bgcolor: "#fff",
  color: "#0D7377",
  fontWeight: 600,
  fontSize: { xs: 13, sm: 14 },
  "& .MuiButton-startIcon": { mr: 0.75 },
  "&:hover": { borderColor: "#0D7377", bgcolor: "#E7F5F5" },
};

const Ordercreation = () => {
  const navigate = useNavigate();
  const { storeData, fetchOrders, setStoreData } = useContext(OrderContext);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const userRole = localStorage.getItem("userRole");
  const token = localStorage.getItem("authToken");
  const [loading, setLoading] = useState(false); // Loader state
  const [latestOrderNumber, setLatestOrderNumber] = useState(null);
  const [invalidFields, setInvalidFields] = useState([]);
  const [orderBannerOpen, setOrderBannerOpen] = useState(false);

  const currentUserId = JSON.parse(localStorage.getItem("user")).id;

  console.log(JSON.parse(localStorage.getItem("user")));

  // Extracting data for dropdowns
  const {
    designs = [],
    finishtypes = [],
    itemtypes = [],
    metaltypes = [],
    purities = [],
    screwTypes = [],
    allstatus = [],
    stores = [],
    karigars = [],
    customers = [],
    MFR = [],
    latestOrder,
    mfrstore,
  } = storeData;

  let mfrId = ""; // Use consistent naming for the variable

  if (
    userRole === "Customer" ||
    userRole === "SEMIMFR" ||
    userRole === "SUPERADMIN" ||
    userRole === "COMFR" ||
    userRole === "Karigar"
  ) {
    mfrId = JSON.parse(localStorage.getItem("selectedMfr"))?.id || ""; // Use 'mfrId' instead of 'mfrid'
  } else if (userRole === "MFR") {
    mfrId = localStorage.getItem("id") || ""; // Use 'mfrId' consistently
  }

  const custid = userRole == "Customer" ? localStorage.getItem("id") : "";

  let selectedStoreIdOld = localStorage.getItem("store_id") || "";

  const defaultStatusId = 1;

  // --- Karigar defaults helpers ---
  const getKarigarDefaultItemTypeId = () => {
    if (userRole === "Karigar" && itemtypes.length > 0) return itemtypes[0].id;
    return "";
  };

  const getKarigarDefaultDesignId = (itemTypeId) => {
    if (userRole === "Karigar" && itemTypeId && designs.length > 0) {
      const filtered = designs.filter((d) => d.itemtype_id === itemTypeId);
      return filtered.length > 0 ? filtered[0].id : "";
    }
    return "";
  };

  const getKarigarDefaultPurityId = () => {
    if (userRole === "Karigar" && purities.length > 0) {
      return purities[0].id;
    }
    return "";
  };
  console.log(allstatus);
  const getKarigarDefaultStatusId = () => {
    if (userRole === "Karigar" && allstatus.length > 0) {
      const InProcess = allstatus.find((s) =>
        s.name?.toLowerCase().includes("in process"),
      );
      return InProcess ? InProcess.id : defaultStatusId;
    }
    return defaultStatusId;
  };

  const getKarigarDefaultStoreId = () => {
    if (userRole === "Karigar" && mfrstore && mfrstore.length > 0)
      return mfrstore[0].id;
    return selectedStoreIdOld || "";
  };

  const getKarigarDefaultKarigarId = () => {
    if (userRole === "Karigar" && karigars.length > 0) {
      const matched = karigars.find((k) => k.id === currentUserId);
      return matched ? matched.id : "";
    }
    return "";
  };

  const today = new Date().toISOString().split("T")[0];

  // State for all form fields
  const [formData, setFormData] = useState({
    selectedDesignId: "",
    selectedFinishId: "",
    selectedItemTypeId: "",
    selectedMetalTypeId: "",
    selectedPurityId: "",
    selectedScrewTypeId: "",
    selectedStatusId: defaultStatusId || "",
    selectedCustmerId: custid || "",
    selectedMFR: mfrId || "",
    selectedStoreId: selectedStoreIdOld || "",
    selectedKarigarId: "",
    orderDeliveryDate: "",
    karigarDeliveryDate: "",
    customername: "",
    pcs: "",
    netWt: "",
    grossWt: "",
    orderDesc: "",
    weightRange: "",
    sampleWeight: "",
    files: [], // Store multiple files here
    orderdate: today,
    orderType: "Customer",
  });

  // Apply Karigar defaults once dropdown data is available
  useEffect(() => {
    if (userRole !== "Karigar") return;

    const karigarItemTypeId = getKarigarDefaultItemTypeId();
    const karigarDesignId = getKarigarDefaultDesignId(karigarItemTypeId);
    const karigarPurityId = getKarigarDefaultPurityId();
    const karigarStatusId = getKarigarDefaultStatusId();
    const karigarStoreId = getKarigarDefaultStoreId();
    const karigarId = getKarigarDefaultKarigarId();

    setFormData((prev) => ({
      ...prev,
      orderdate: today,
      orderDeliveryDate: today,
      karigarDeliveryDate: today,
      selectedItemTypeId: karigarItemTypeId || prev.selectedItemTypeId,
      selectedDesignId: karigarDesignId || prev.selectedDesignId,
      selectedPurityId: karigarPurityId || prev.selectedPurityId,
      grossWt: "1",
      netWt: "1",
      pcs: "1",
      orderDesc: "Created by Karigar",
      selectedKarigarId: karigarId || prev.selectedKarigarId,
      selectedStatusId: karigarStatusId || prev.selectedStatusId,
      selectedCustmerId: karigarStoreId || prev.selectedCustmerId,
    }));
  }, [
    userRole,
    itemtypes.length,
    designs.length,
    purities.length,
    allstatus.length,
    karigars.length,
    mfrstore?.length,
  ]);

  const handleFieldChange = (field, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  // Handler for when a file is selected or dropped
  const onDrop = (acceptedFiles) => {
    setFormData((prevState) => ({
      ...prevState,
      files: [...prevState.files, ...acceptedFiles], // Append new files to the existing ones
    }));
  };

  // Dropzone configuration
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "image/*, video/*,application/pdf", // Accept both images and videos
    multiple: true, // Allow multiple files
  });

  const handleRemoveFile = (indexToRemove) => {
    setFormData((prev) => ({
      ...prev,
      files: prev.files.filter((_, index) => index !== indexToRemove),
    }));
  };

  // Helper function to map options
  // const mapOptions = (data) => data.map((item) => ({ id: item.id, name: item.name }));

  const mapOptions = (data = []) =>
    data.map((item) => ({ id: item.id, name: item.name }));

  // Validate the form before submission
  const validateForm = () => {
    const requiredFields = [
      "selectedDesignId",
      "selectedItemTypeId",
      "selectedStatusId",
      "orderDeliveryDate",
      "orderdate",
    ];

    const itemTypeIdsRequiringScrewType = [2085, 2079, 2080]; // Replace these with the actual IDs for Bangle, Jumki, and Tops

    // Add selectedScrewTypeId conditionally based on selectedItemTypeId
    if (itemTypeIdsRequiringScrewType.includes(formData.selectedItemTypeId)) {
      requiredFields.push("selectedScrewTypeId");
    }

    for (let field of requiredFields) {
      if (!formData[field]) {
        setSnackbarMessage(
          `Please fill the ${field
            .replace("Id", "")
            .replace(/([A-Z])/g, " $1")
            .toLowerCase()} field.`,
        );
        setSnackbarOpen(true);
        return false;
      }
    }

    // If everything is valid, submit the form
    handleFormSubmit();
    return true;
  };

  const handleFormSubmit = async () => {
    setLoading(true);
    setInvalidFields([]);

    const showError = (label, fieldKey) => {
      setSnackbarMessage(`${label} is required`);
      setSnackbarOpen(true);
      setInvalidFields([fieldKey]); // Highlight using this key
      setLoading(false);

      // Optional: Scroll and focus to the input
      const fieldElement = document.getElementById(fieldKey);
      if (fieldElement) {
        fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
        fieldElement.focus();
      }
    };

    if (!formData.orderdate) return showError("Order Date", "orderdate");
    if (!formData.selectedMFR) return showError("Manufacturer", "selectedMFR");
    if (!formData.orderDeliveryDate)
      return showError("Delivery Date", "orderDeliveryDate");
    if (!formData.selectedItemTypeId)
      return showError("Item Type", "selectedItemTypeId");
    if (!formData.selectedDesignId)
      return showError("Design Type", "selectedDesignId");
    if (!formData.grossWt) return showError("Gross Weight", "grossWt");
    if (userRole == !"SEMIMFR") {
      if (!formData.selectedKarigarId)
        return showError("Karigar", "selectedKarigarId");
    }

    try {
      const data = new FormData(); // Create a FormData object for multipart data

      for (let key in formData) {
        if (key !== "files" && formData[key] !== null) {
          data.append(key, formData[key]);
        }
      }

      // Append each file with the correct field name 'files'
      formData.files.forEach((file) => {
        data.append("files", file); // Append the files with the name 'files'
      });

      let storeIdToUse = formData.selectedStoreId;
      if (
        userRole === "MFR" ||
        userRole === "SEMIMFR" ||
        userRole === "SUPERADMIN" ||
        userRole === "COMFR"
      ) {
        storeIdToUse = formData.selectedCustmerId;
        data.set("selectedCustmerId", null);
      }

      storeIdToUse = Number(storeIdToUse);

      // *** Overwrite, don't append again ***
      data.set("selectedStoreId", storeIdToUse); // Use data.set to overwrite

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/orders/createorder`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data", // Ensure this is set to handle file uploads
          },
        },
      );

      // setLatestOrderNumber(response.data.data.storeorderno);

      // setSnackbarMessage(`Order Created successfully! Order number is ${response.data.data.storeorderno}`);
      setLatestOrderNumber(response.data.data.storeorderno);

      setStoreData((prevStoreData) => ({
        ...prevStoreData,
        latestOrder: response.data.nextincrement,
      }));
      await fetchOrders();

      // Karigar: skip the success banner and go straight to the order's detail
      // page with the freshly-created order selected. Enrich with display names
      // (the create API returns ids only) that /order-details renders.
      if (userRole === "Karigar") {
        const createdOrder = response.data.data;
        const enrichedOrder = {
          ...createdOrder,
          itemtype_name: itemtypes.find(
            (i) => i.id === Number(createdOrder.itemtype_id)
          )?.name,
          design_name: designs.find(
            (d) => d.id === Number(createdOrder.design_id)
          )?.name,
          finishtype_name: finishtypes.find(
            (f) => f.id === Number(createdOrder.finishtype_id)
          )?.name,
          karigar_name: karigars.find(
            (k) => k.id === Number(createdOrder.karigar_id)
          )?.name,
        };
        setLoading(false);
        navigate("/order-details", { state: { order: enrichedOrder } });
        return;
      }

      setOrderBannerOpen(true); // 👈 Show the slide-up (non-Karigar)

      // Optional: Reset the form if desired
      const resetKarigarItemTypeId =
        userRole === "Karigar" && itemtypes.length > 0 ? itemtypes[0].id : "";
      const resetKarigarDesignId = getKarigarDefaultDesignId(
        resetKarigarItemTypeId,
      );

      setFormData({
        selectedStatusId:
          userRole === "Karigar"
            ? getKarigarDefaultStatusId()
            : defaultStatusId || "",
        selectedCustmerId:
          userRole === "Karigar" ? getKarigarDefaultStoreId() : custid || "",
        selectedMFR: mfrId || "",
        selectedStoreId: selectedStoreIdOld || "",
        selectedDesignId: userRole === "Karigar" ? resetKarigarDesignId : "",
        selectedFinishId: "",
        selectedItemTypeId:
          userRole === "Karigar" ? resetKarigarItemTypeId : "",
        selectedMetalTypeId: "",
        selectedPurityId:
          userRole === "Karigar" ? getKarigarDefaultPurityId() : "",
        selectedScrewTypeId: "",
        selectedKarigarId:
          userRole === "Karigar" ? getKarigarDefaultKarigarId() : "",
        orderDeliveryDate: userRole === "Karigar" ? today : "",
        storeorderno: "",
        customername: "",
        karigarDeliveryDate: userRole === "Karigar" ? today : "",
        semiWeight: "",
        size: "",
        pcs: userRole === "Karigar" ? "1" : "",
        netWt: userRole === "Karigar" ? "1" : "",
        grossWt: userRole === "Karigar" ? "1" : "",
        orderDesc: userRole === "Karigar" ? "Created by Karigar" : "",
        weightRange: "",
        sampleWeight: "",
        files: [], // Reset files after submission
        orderdate: today,
        orderType: "Customer",
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      setSnackbarMessage(error.response.data.data.message);
      setSnackbarOpen(true);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  // Close Snackbar
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  // Remove a file from the list
  const removeFile = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      files: prevState.files.filter((_, i) => i !== index),
    }));
  };

  const isFieldInvalid = (field) => invalidFields.includes(field);

  useEffect(() => {
    if (orderBannerOpen) {
      const timer = setTimeout(() => {
        setOrderBannerOpen(false);
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [orderBannerOpen]);

  return (
    <Container maxWidth="lg" className="container">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: { xs: "column", md: "row" },
          // gap: 1,
          mb: 2,
        }}
      >
        <Box>
          <h2 className="new-order-heading">Create New Orders</h2>
          <p className="new-order-note">
            Fields marked with <span style={{ color: "red" }}>*</span> are
            mandatory.
          </p>
        </Box>

        {userRole !== "Karigar" && (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              width: { xs: "100%", md: "auto" },
            }}
          >
            <Button
              variant="outlined"
              startIcon={<LibraryAddOutlined />}
              onClick={() => navigate("/bulkorder")}
              sx={headerActionSx}
            >
              Create Bulk Orders
            </Button>

            <Button
              variant="outlined"
              startIcon={<StorefrontOutlined />}
              onClick={() => navigate("/bulkexhibitionorder")}
              sx={headerActionSx}
            >
              Create Exhibition Orders
            </Button>
          </Box>
        )}
      </Box>

      <div className="grid-container">
        {/* Row 1 */}
        <div className="grid-item">
          <TextField
            label="Order Number"
            variant="outlined"
            value={latestOrder}
            onChange={(e) => handleFieldChange("orderno", e.target.value)}
            fullWidth
            disabled
            InputLabelProps={{ shrink: true }}
            className="custom-textfield"
          />
        </div>

        <div className="grid-item">
          <TextField
            label="Order Date"
            type="date"
            variant="outlined"
            value={formData.orderdate || today}
            onChange={(e) => handleFieldChange("orderdate", e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ width: "100%" }}
            className={`custom-textfield ${
              isFieldInvalid("orderdate") ? "invalid-field" : ""
            }`}
            disabled={userRole === "Karigar"}
          />
        </div>

        <div
          className={` ${
            userRole === "Customer" ? "grid-item-full" : "grid-item"
          }`}
        >
          <TextField
            label={
              <span>
                Order Delivery Date <span style={{ color: "red" }}>*</span>
              </span>
            }
            type="date"
            variant="outlined"
            value={formData.orderDeliveryDate}
            // required
            onChange={(e) => {
              const orderDate = e.target.value;
              handleFieldChange("orderDeliveryDate", orderDate);

              // Automatically set Karigar Delivery Date (4 days less)
              if (orderDate) {
                const karigarDate = new Date(orderDate);
                karigarDate.setDate(karigarDate.getDate() - 4); // Subtract 4 days
                handleFieldChange(
                  "karigarDeliveryDate",
                  karigarDate.toISOString().split("T")[0],
                ); // Format to 'YYYY-MM-DD'
              }
            }}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ width: "100%" }}
            className={`custom-textfield ${
              isFieldInvalid("orderDeliveryDate") ? "invalid-field" : ""
            }`}
            disabled={userRole === "Karigar"}
          />
        </div>

        {(userRole === "MFR" || userRole === "Karigar") && (
          <div className="grid-item">
            <TextField
              label="Karigar Delivery Date"
              type="date"
              variant="outlined"
              value={formData.karigarDeliveryDate}
              onChange={(e) =>
                handleFieldChange("karigarDeliveryDate", e.target.value)
              }
              InputLabelProps={{
                shrink: true,
              }}
              style={{ width: "100%" }}
              className="custom-textfield"
              disabled={userRole === "Karigar"}
            />
          </div>
        )}

        <div className="grid-item">
          <TextField
            label="Customer Order Number"
            variant="outlined"
            value={formData.storeorderno}
            onChange={(e) => handleFieldChange("storeorderno", e.target.value)}
            fullWidth
            className="custom-textfield"
          />
        </div>

        <div className="grid-item">
          <TextField
            label="Customer Name"
            variant="outlined"
            value={formData.customername}
            onChange={(e) => handleFieldChange("customername", e.target.value)}
            fullWidth
            className="custom-textfield"
          />
        </div>

        <div className="grid-item">
          <Autocomplete
            options={mapOptions(itemtypes)}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField
                {...params}
                label={
                  <span>
                    Item Type <span style={{ color: "red" }}>*</span>
                  </span>
                }
                variant="outlined"
                className="dropdown"
              />
            )}
            value={
              formData.selectedItemTypeId
                ? {
                    id: formData.selectedItemTypeId,
                    name: itemtypes.find(
                      (i) => i.id === formData.selectedItemTypeId,
                    )?.name,
                  }
                : null
            }
            onChange={(event, newValue) => {
              handleFieldChange("selectedItemTypeId", newValue?.id || "");
              handleFieldChange("selectedDesignId", ""); // Reset Design if Item Type changes
            }}
            className={`custom-textfield ${
              isFieldInvalid("selectedItemTypeId") ? "invalid-field" : ""
            }`}
            // disabled={userRole === "Karigar"}
          />
        </div>

        <div className="grid-item">
          <Autocomplete
            options={
              formData.selectedItemTypeId
                ? mapOptions(
                    designs.filter(
                      (d) => d.itemtype_id === formData.selectedItemTypeId,
                    ), // Filter designs dynamically
                  )
                : []
            }
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField
                {...params}
                label={
                  <span>
                    Design <span style={{ color: "red" }}>*</span>
                  </span>
                }
                variant="outlined"
                className="dropdown"
              />
            )}
            value={
              formData.selectedDesignId
                ? {
                    id: formData.selectedDesignId,
                    name: designs.find(
                      (d) => d.id === formData.selectedDesignId,
                    )?.name,
                  }
                : null
            }
            onChange={(event, newValue) =>
              handleFieldChange("selectedDesignId", newValue?.id)
            }
            disabled={!formData.selectedItemTypeId}
            className={`custom-textfield ${
              isFieldInvalid("selectedDesignId") ? "invalid-field" : ""
            }`}
          />
        </div>

        {/* Purity */}
        <div className="grid-item">
          <Autocomplete
            options={mapOptions(purities)}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField
                {...params}
                label={
                  <span>
                    Purity <span style={{ color: "red" }}>*</span>
                  </span>
                }
                variant="outlined"
                className="dropdown"
              />
            )}
            value={
              formData.selectedPurityId
                ? {
                    id: formData.selectedPurityId,
                    name: purities.find(
                      (purity) => purity.id === formData.selectedPurityId,
                    )?.name,
                  }
                : null
            }
            onChange={(event, newValue) => {
              handleFieldChange("selectedPurityId", newValue?.id || "");
            }}
            className={`custom-textfield ${
              isFieldInvalid("selectedPurityId") ? "invalid-field" : ""
            }`}
            // disabled={userRole === "Karigar"}
          />
        </div>

        <div className="grid-item">
          <TextField
            label={
              <span>
                Gross Weight <span style={{ color: "red" }}>*</span>
              </span>
            }
            variant="outlined"
            value={formData.grossWt}
            onChange={(e) => handleFieldChange("grossWt", e.target.value)}
            fullWidth
            className={`custom-textfield ${
              isFieldInvalid("grossWt") ? "invalid-field" : ""
            }`}
            // disabled={userRole === "Karigar"}
          />
        </div>

        <div className="grid-item">
          <TextField
            label="Net Weight"
            variant="outlined"
            value={formData.netWt}
            onChange={(e) => handleFieldChange("netWt", e.target.value)}
            fullWidth
            className="custom-textfield"
            // disabled={userRole === "Karigar"}
          />
        </div>

        <div className="grid-item">
          <TextField
            // label="Pcs"
            label={
              <span>
                Pcs <span style={{ color: "red" }}>*</span>
              </span>
            }
            variant="outlined"
            value={formData.pcs}
            onChange={(e) => handleFieldChange("pcs", e.target.value)}
            fullWidth
            className="custom-textfield"
            // disabled={userRole === "Karigar"}
          />
        </div>

        <div className="grid-item">
          <Autocomplete
            options={mapOptions(finishtypes)}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Color"
                variant="outlined"
                className="dropdown"
              />
            )}
            value={
              formData.selectedFinishId
                ? {
                    id: formData.selectedFinishId,
                    name: finishtypes.find(
                      (f) => f.id === formData.selectedFinishId,
                    )?.name,
                  }
                : null
            }
            onChange={(event, newValue) =>
              handleFieldChange("selectedFinishId", newValue?.id)
            }
            className="custom-textfield"
          />
        </div>

        <div className="grid-item-full" style={{ gridColumn: "span 2" }}>
          <TextField
            label="Order Description"
            variant="outlined"
            value={formData.orderDesc}
            onChange={(e) => handleFieldChange("orderDesc", e.target.value)}
            fullWidth
            multiline
            rows={4} // Adjust the number of rows as needed
            className="custom-textfield"
            disabled={userRole === "Karigar"}
          />
        </div>

        <div className="grid-item">
          <TextField
            label="Sample Weight"
            variant="outlined"
            value={formData.sampleWeight}
            onChange={(e) => handleFieldChange("sampleWeight", e.target.value)}
            fullWidth
            className="custom-textfield"
          />
        </div>

        <div className="grid-item">
          <TextField
            label="Semi Finished Weight"
            variant="outlined"
            value={formData.semiWeight}
            onChange={(e) => handleFieldChange("semiWeight", e.target.value)}
            fullWidth
            className="custom-textfield"
          />
        </div>

        {(userRole === "MFR" ||
          userRole === "SUPERADMIN" ||
          userRole === "COMFR" ||
          userRole === "Karigar") && (
          <div className="grid-item">
            <Autocomplete
              options={mapOptions(karigars)}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  //  label="Karigar"
                  label={
                    <span>
                      Karigar <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  variant="outlined"
                  className="dropdown"
                />
              )}
              value={
                formData.selectedKarigarId
                  ? {
                      id: formData.selectedKarigarId,
                      name: karigars.find(
                        (k) => k.id === formData.selectedKarigarId,
                      )?.name,
                    }
                  : null
              }
              onChange={(event, newValue) =>
                handleFieldChange("selectedKarigarId", newValue?.id)
              }
              className={`custom-textfield ${
                isFieldInvalid("selectedKarigarId") ? "invalid-field" : ""
              }`}
              disabled={userRole === "Karigar"}
            />
          </div>
        )}

        <div className="grid-item">
          <TextField
            label="Size/Length"
            variant="outlined"
            value={formData.size}
            onChange={(e) => handleFieldChange("size", e.target.value)}
            fullWidth
            className="custom-textfield"
          />
        </div>

        {/* Status and Store */}
        {userRole !== "Customer" && (
          <div
            className={` ${
              userRole === "Customer" ? "grid-item-full" : "grid-item"
            }`}
          >
            <Autocomplete
              options={mapOptions(allstatus)}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Status"
                  variant="outlined"
                  className="dropdown"
                />
              )}
              value={
                formData.selectedStatusId
                  ? {
                      id: formData.selectedStatusId,
                      name: allstatus.find(
                        (a) => a.id === formData.selectedStatusId,
                      )?.name,
                    }
                  : { id: 1, name: allstatus.find((a) => a.id === 1)?.name } // Default to "New" (id: 1)
              }
              onChange={(event, newValue) =>
                handleFieldChange("selectedStatusId", newValue?.id)
              }
              className="custom-textfield"
              disabled={userRole === "Karigar"}
            />
          </div>
        )}

        {userRole === "MFR" && (
          <div className="grid-item">
            <Autocomplete
              options={mapOptions(mfrstore)}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={
                    <span>
                      Store Name <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  variant="outlined"
                  className="dropdown"
                />
              )}
              value={
                formData.selectedCustmerId
                  ? {
                      id: formData.selectedCustmerId,
                      name: mfrstore.find(
                        (a) => a.id === formData.selectedCustmerId,
                      )?.name,
                    }
                  : null
              }
              onChange={(event, newValue) =>
                handleFieldChange("selectedCustmerId", newValue?.id)
              }
              className="custom-textfield"
            />
          </div>
        )}

        {(userRole === "SUPERADMIN" || userRole === "COMFR") &&
          mfrstore?.length > 0 && (
            <div className="grid-item">
              <Autocomplete
                options={mapOptions(mfrstore)}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <span>
                        Store Name <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    variant="outlined"
                    className="dropdown"
                  />
                )}
                value={
                  formData.selectedCustmerId
                    ? {
                        id: formData.selectedCustmerId,
                        name:
                          mfrstore.find(
                            (a) => a.id === formData.selectedCustmerId,
                          )?.name || "",
                      }
                    : null
                }
                onChange={(event, newValue) =>
                  handleFieldChange("selectedCustmerId", newValue?.id)
                }
                className="custom-textfield"
              />
            </div>
          )}

        {/* 
        {userRole === 'SUPERADMIN' && (
          <div className="grid-item">
            <Autocomplete
              options={mapOptions(mfrstore)}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField {...params} label="Store Name" variant="outlined" className="dropdown" />
              )}
              value={formData.selectedCustmerId ? { id: formData.selectedCustmerId, name: mfrstore.find(a => a.id === formData.selectedCustmerId)?.name } : null}
              onChange={(event, newValue) => handleFieldChange('selectedCustmerId', newValue?.id)}
            />
          </div>
        )} */}

        {userRole === "SEMIMFR" && (
          <div className="grid-item">
            <Autocomplete
              options={mapOptions(customers)}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={
                    <span>
                      Store Name <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  variant="outlined"
                  className="dropdown"
                />
              )}
              value={
                formData.selectedCustmerId
                  ? {
                      id: formData.selectedCustmerId,
                      name: customers.find(
                        (a) => a.id === formData.selectedCustmerId,
                      )?.name,
                    }
                  : null
              }
              onChange={(event, newValue) =>
                handleFieldChange("selectedCustmerId", newValue?.id)
              }
              className="custom-textfield"
            />
          </div>
        )}

        {/* Karigar Store Name (mfrstore first option, disabled) */}
        {userRole === "Karigar" && mfrstore && mfrstore.length > 0 && (
          <div className="grid-item">
            <Autocomplete
              options={mapOptions(mfrstore)}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={
                    <span>
                      Store Name <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  variant="outlined"
                  className="dropdown"
                />
              )}
              value={
                formData.selectedCustmerId
                  ? {
                      id: formData.selectedCustmerId,
                      name:
                        mfrstore.find(
                          (a) => a.id === formData.selectedCustmerId,
                        )?.name || "",
                    }
                  : null
              }
              onChange={(event, newValue) =>
                handleFieldChange("selectedCustmerId", newValue?.id)
              }
              className="custom-textfield"
              disabled
            />
          </div>
        )}

        <div className="grid-item">
          <Autocomplete
            options={mapOptions(screwTypes)}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Screw Type"
                variant="outlined"
                className="dropdown"
              />
            )}
            value={
              formData.selectedScrewTypeId
                ? {
                    id: formData.selectedScrewTypeId,
                    name: screwTypes.find(
                      (s) => s.id === formData.selectedScrewTypeId,
                    )?.name,
                  }
                : null
            }
            onChange={(event, newValue) =>
              handleFieldChange("selectedScrewTypeId", newValue?.id)
            }
            className="custom-textfield"
          />
        </div>

        <div className="grid-item">
          <TextField
            select
            fullWidth
            label={<span>Order Type</span>}
            value={formData.orderType}
            onChange={(e) => handleFieldChange("orderType", e.target.value)}
            variant="outlined"
            className={`custom-textfield ${
              isFieldInvalid("orderType") ? "invalid-field" : ""
            }`}
          >
            <MenuItem value="Stock">Stock</MenuItem>
            <MenuItem value="Customer">Customer</MenuItem>
          </TextField>
        </div>

        <div className="grid-item-full">
          <TextField
            label="Weight Range"
            variant="outlined"
            value={formData.weightRange}
            onChange={(e) => handleFieldChange("weightRange", e.target.value)}
            fullWidth
            multiline
            rows={3}
            className="custom-textfield"
          />
        </div>

        <div
          {...getRootProps()}
          className={`dropzone ${isDragActive ? "active" : ""}`}
        >
          <input {...getInputProps()} />
          <p>
            <span className="upload-highlight">Click here</span> to upload
            images/videos
          </p>
        </div>

        <div className="media-grid">
          {formData.files.map((file, index) => (
            <div className="media-item" key={index}>
              <button
                className="remove-button"
                onClick={() => handleRemoveFile(index)}
                type="button"
              >
                ×
              </button>

              {file.type.startsWith("image") ? (
                <img src={URL.createObjectURL(file)} alt={`img-${index}`} />
              ) : file.type.startsWith("video") ? (
                <video src={URL.createObjectURL(file)} controls />
              ) : file.type === "application/pdf" ? (
                // Preview PDF in iframe or link
                <iframe
                  src={URL.createObjectURL(file)}
                  title={`pdf-${index}`}
                  width="100%"
                  height="300px"
                ></iframe>
              ) : (
                <p>Unsupported file type</p>
              )}
            </div>
          ))}
        </div>

        <div className="submit-button-container">
          <Button
            variant="contained"
            color="primary"
            onClick={handleFormSubmit}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Save Order"
            )}
          </Button>
        </div>

        {/* {latestOrderNumber && (
          <Typography variant="h6" color="green" sx={{ mt: 2 }}>
            Previos Order ID <strong>{latestOrderNumber}</strong>
          </Typography>
        )} */}

        {/* File Previews */}
        {/* <div className="image-submit-container">
          {formData.files.map((file, index) => (
            <div key={index} className="file-preview">
              {file.type.startsWith('image') ? (
                <img src={URL.createObjectURL(file)} alt={`uploaded preview ${index}`} style={{ width: '100%', maxHeight: '300px', objectFit: 'contain', marginTop: '10px' }} />
              ) : (
                <video controls style={{ width: '100%', maxHeight: '300px', marginTop: '10px' }}>
                  <source src={URL.createObjectURL(file)} type={file.type} />
                  Your browser does not support the video tag.
                </video>
              )}
              <Typography variant="body1">{file.name}</Typography>
              <Button variant="outlined" color="secondary" onClick={() => removeFile(index)}>
                Remove
              </Button>
            </div>
          ))}
        </div> */}

        <Slide direction="up" in={orderBannerOpen} mountOnEnter unmountOnExit>
          <Paper
            elevation={4}
            sx={{
              position: "fixed",
              bottom: 0,
              left: 0,
              width: "100%",
              bgcolor: "background.paper",
              px: 4,
              py: 3,
              zIndex: 1400,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              borderTop: "4px solid #0D7377",
            }}
          >
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Order Created Successfully
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              Your order has been successfully created. <br />
              Below is the order number for your reference.
            </Typography>

            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ color: "#0D7377", mb: 2 }} // match Save button color
            >
              Order ID: {latestOrderNumber}
            </Typography>

            <Button
              variant="contained"
              onClick={() => setOrderBannerOpen(false)}
              sx={{
                backgroundColor: "#0D7377",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#0A5C60", // optional hover effect
                },
              }}
            >
              Close
            </Button>
          </Paper>
        </Slide>

        {/* Snackbar for showing error messages */}
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          sx={{
            "&.MuiSnackbar-root": {
              bottom: "100px !important", // force override snackbar position
            },
          }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </div>
    </Container>
  );
};

export default Ordercreation;
